import React from 'react';
import {FC, Fragment} from 'react';
import {useArchiveDirectoryForm} from './use-archive-directory-form';
import Button from 'components/button';
import {Trans, useTranslation} from 'react-i18next';
import {ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

const ArchiveDirectoryConfirm: FC<Props> = props => {
  const {onDismiss} = props;

  const {t} = useTranslation();

  const {submit, isLoading, message} = useArchiveDirectoryForm(onDismiss);

  return (
    <Fragment>
      <ModalHeader className="bg-primary" toggle={onDismiss}>
        <span className="text-light">
          <Trans i18nKey={'alertCloak.alertTitle'} />
        </span>
      </ModalHeader>

      <ModalBody className="">
        <p>{message} </p>
      </ModalBody>
      <ModalFooter>
        <Button color="important" onClick={submit} isLoading={isLoading}>
          {t('actionVariantModal.yesImSure')}
        </Button>
        <Button color="secondary" onClick={onDismiss}>
          {t('actionVariantModal.cancel')}
        </Button>
      </ModalFooter>
    </Fragment>
  );
};

interface Props {
  message?: string;
  onDismiss: () => void;
}

export default ArchiveDirectoryConfirm;
